<template>
    <div class="intro lg:flex flex-1 items-center lg:max-w-6xl lg:mx-auto w-full mx-auto">
        <ImagePlaceholder>
            <img class="w-full" src="/img/illustrations/intro.png" alt="Quiz" />
        </ImagePlaceholder>
        <form action="#" @submit.prevent="submit" class="relative flex-1">
            <h1 class="">Ești gata?</h1>
            <p class="">Știi să rămâi în siguranță online? Ești relaxat, vigilent sau agil? Știi să-ți ții cardul, conturile și propria imagine la adăpost de orice pericol? E mai tricky decât crezi! Răspunde la întrebări și vezi ce scor de siguranță obții!</p>
            <Button autofocus type="submit">Începe quizul</Button>
            <PointsTriangle class="points" />
        </form>
    </div>
</template>

<script>
import Button from "../Common/Button.vue";
import PointsTriangle from "./Vector/PointsTriangle.vue";
import ImagePlaceholder from "./Vector/ImagePlaceholder.vue";

export default {
	name: "IntroComponent",
	components: {ImagePlaceholder, PointsTriangle, Button},
	emits: ["submit"],
	methods: {
		submit() {
			this.$emit("submit");
		}
	}
};
</script>

<style lang="scss">
.intro {
    --title-size: 24px;
    --title-leading: 30px;
    --title-margin: 0 0 20px;
    --paragraph-size: 14px;
    --paragraph-leading: 22px;
    --paragraph-margin: 0 0 20px;
    --padding: 27px 30px 40px;
    --form-border: 2px solid black;
    --form-border-radius: 10px;
    --form-shadow: 6px 6px 18px rgba(0, 0, 0, 0.2);
    --image-width: 100%;

    position: relative;
    z-index: 2;

    .image {
        width: var(--image-width);
        margin: 0;
    }

    form {
        position: relative;
        padding: var(--padding);
        background: white;
        border: var(--form-border);
        box-shadow: var(--form-shadow);
        border-radius: var(--form-border-radius);
        z-index: 2;
        margin: 0 15px 15px;

        h1 {
            font-style: normal;
            font-weight: 900;
            font-size: var(--title-size);
            line-height: var(--title-leading);
            text-transform: uppercase;
            margin: var(--title-margin);
        }

        p {
            font-style: normal;
            font-weight: 500;
            font-size: var(--paragraph-size);
            line-height: var(--paragraph-leading);
            margin: var(--paragraph-margin);
        }

        .points {
            position: absolute;
            right: 15px;
            bottom: 15px;
        }
    }


    @media (min-width: 1024px) {
        --title-size: 38px;
        --title-leading: 46px;
        --paragraph-size: 18px;
        --paragraph-leading: 26px;
        --paragraph-margin: 0 0 50px;
        --padding: 50px 56px;
        --form-border: 4px solid black;
        --form-border-radius: 20px;
        --form-shadow: 10px 10px 26px rgba(0, 0, 0, 0.15);
        --image-width: 50vw;

        margin: 0 auto;

        gap: 30px;

        .image {
            position: relative;
            width: 100%;
            margin: 0;
            border: var(--form-border);
            border-radius: var(--form-border-radius);
            overflow: hidden;
        }
        form {
            flex: 0 0 50%;
            margin: 0;
        }
    }
}
</style>
